import React from 'react';
import 'react-table-v6/react-table.css';
import Select from 'react-select';
import FormField from '../../../../../components/FormField';
import TextInput from '../../../../../components/TextInput';
import TextArea from '../../../../../components/TextArea';

const SleepMeditationAudioFormScreen = ({
  touched,
  errors,
  hormoneYValues,
  values,
  setFieldTouched,
  setFieldValue,
}) => {
  return (
    <div style={{ overflowY: 'auto' }}>
      <FormField mb={3} error={touched.phone && errors.phone}>
        <label htmlFor="title">Title</label>
        <TextInput name="title" placeholder="Title" />
      </FormField>

      <FormField mb={3} error={touched.phone && errors.phone}>
        <label htmlFor="content">Audio file URL</label>
        <TextArea name="Content" placeholder="Content" />
      </FormField>

      <FormField mb={4} error={touched.phone && errors.phone}>
        <label htmlFor="hormoneY">background positions</label>
        <Select
          classNamePrefix="region-select"
          options={hormoneYValues}
          name="hormoneY"
          value={values.hormoneY}
          placeholder="select background positions"
          onChange={option => {
            setFieldValue('hormoneY', option);
          }}
          onBlur={() => setFieldTouched('hormoneY', true)}
          isSearchable={true}
        />
      </FormField>
    </div>
  );
};

export default SleepMeditationAudioFormScreen;
